import React, { Component, ReactNode } from 'react'

interface ContentLayoutProps {
  noGap?: boolean
  className?: string
  children: ReactNode
}

export default class ContentLayout extends Component<ContentLayoutProps> {
  get className () {
    const base = 'flex flex-wrap lg:flex-nowrap'
    const gap = this.props.noGap ? '' : 'gap-5'
    return `${base} ${gap} ${this.props.className}`
  }

  render () {
    return (
      <div className={this.className}>
        {this.props.children}
      </div>
    )
  }
}
